import { createSlice } from "@reduxjs/toolkit";

export enum POINT_EDIT_TYPE {
  NONE,
  POINT,
  DRAWING,
  FILTER,
}

type GeneralState = {
  isEditMode: POINT_EDIT_TYPE;
}

const initialState: GeneralState = {
  isEditMode: POINT_EDIT_TYPE.NONE,
}

export const generalSlice = createSlice({
  name: 'generalState',
  initialState,
  reducers: {
    setEditMode: (state, action) => {
      state.isEditMode = action.payload ? action.payload : POINT_EDIT_TYPE.NONE;
    }
  },
});

export const { setEditMode } = generalSlice.actions;